import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import PlanCreateForm from './PlanCreateForm';
import PlanEditForm from './PlanEditForm';
import s from './Plans.module.scss'

const Plans = () => {
    const navigate = useNavigate();
    const [showCreateForm, setShowCreateForm] = useState(false);
    const { tour_detail_id } = useParams();
    const [plans, setPlans] = useState([]);
    console.log('plans', plans)
    const [loading, setLoading] = useState(true);
    const [selectedPlan, setSelectedPlan] = useState(null);
    console.log('selectedPlan',selectedPlan)
    console.log('plans',plans)
    const [newPlan, setNewPlan] = useState({
      campaign: '',
      duration: '',
      transfer: false,
      japanese_guide: false,
      availability: '毎日',
      ad_price: '',
      ch_price: '',
      family_price: '',
      includes: [''],
      // schedules: [{ time: '', event: '', image: null, notes: '' }]
    });

    const [newSchedules, setNewSchedules] = useState([{ time: '', event: '', image: null, notes: '' }]);
    const apiUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
      const fetchPlans = async () => {
          setLoading(true);
          try {
              const response = await axios.get(`${apiUrl}/api/admin/plans/${tour_detail_id}`);
              const data = response.data;
              setPlans(data);
          } catch (error) {
              console.error('Error fetching plans:', error);
          } finally {
              setLoading(false);
          }
      };

      fetchPlans();
  }, [tour_detail_id]);


  const handleShowCreateForm = () => {
    setShowCreateForm(true);
};


  const handleNewPlanChange = (e) => {
    setNewPlan({
      ...newPlan,
      [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  const handleEditPlanChange = (e) => {
    setSelectedPlan({
      ...selectedPlan,
      [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  const handleCreateNewPlan = async (e) => {
    e.preventDefault();
    console.log('newPlan before filtering', newPlan);

    const filteredSchedules = newPlan.schedules.filter(schedule => schedule.time.trim() !== '');

    const updatedPlan = {
      ...newPlan,
      tour_detail_id,
      schedules: filteredSchedules,
    };

    console.log('newPlan after filtering', updatedPlan);
    try {
      const response = await axios.post(`${apiUrl}/api/admin/plans/create`, updatedPlan);

      setPlans(response.data.plans);
      setNewPlan({
        campaign: '',
        duration: '',
        transfer: false,
        japanese_guide: false,
        availability: '毎日',
        ad_price: '',
        ch_price: '',
        family_price: '',
        includes: [''],
        schedules: [{ time: '', event: '', notes: '' }]
    });
    setShowCreateForm(false)
    } catch (error) {
      console.error('Error creating plan:', error);
    }
  };

  const handleEditPlan = async (e) => {
    e.preventDefault();
    const filteredSchedules = (selectedPlan.schedules || []).filter(schedule => schedule.time && schedule.time.trim() !== '');

    console.log('updatedData', selectedPlan)
    console.log('filteredSchedules', filteredSchedules)
    const updatedPlan = {
        ...selectedPlan,
        schedules: filteredSchedules,
    };

    try {
        const response = await axios.put(`${apiUrl}/api/admin/plans/${selectedPlan.id}`, updatedPlan);

        setPlans(response.data.plans);
        setSelectedPlan(null);
    } catch (error) {
        console.error('Error updating plan:', error);
    }
};

  const handleCancelEdit = () => {
    setSelectedPlan(null);
    setShowCreateForm(false);
    setNewPlan({
      campaign: '',
      duration: '',
      transfer: false,
      japanese_guide: false,
      availability: '毎日',
      ad_price: '',
      ch_price: '',
      family_price: '',
      includes: [''],
      schedules: [{ time: '', event: '', image: null, notes: '' }] // 初期状態にリセット
    });
  };

  const handleAddInclude = () => {
    setNewPlan({
      ...newPlan,
      includes: [...newPlan.includes, ''],
    });
  };

  const handleIncludeChange = (index, value) => {
    const updatedIncludes = newPlan.includes.map((item, i) =>
      i === index ? value : item
    );
    setNewPlan({ ...newPlan, includes: updatedIncludes });
  };

  const handleRemoveInclude = (index) => {
    const updatedIncludes = newPlan.includes.filter((_, i) => i !== index);
    setNewPlan({ ...newPlan, includes: updatedIncludes });
  };

  const handleEditAddInclude = () => {
    setSelectedPlan({
      ...selectedPlan,
      includes: [...selectedPlan.includes, ''],
    });
  };

  const handleDeletePlan = async (planId) => {
    if (!window.confirm('このプランを削除しますか？')) return;

    try {
        await axios.delete(`${apiUrl}/api/admin/plans/delete/${planId}`);
        setPlans((prevPlans) => prevPlans.filter((plan) => plan.id !== planId));
    } catch (error) {
        console.error('Error deleting plan:', error);
    }
};

  const handleEditIncludeChange = (index, value) => {
    const updatedIncludes = selectedPlan.includes.map((item, i) =>
      i === index ? value : item
    );
    setSelectedPlan({ ...selectedPlan, includes: updatedIncludes });
  };

  const handleEditRemoveInclude = (index) => {
    const updatedIncludes = selectedPlan.includes.filter((_, i) => i !== index);
    setSelectedPlan({ ...selectedPlan, includes: updatedIncludes });
  };

  const handleScheduleChange = (index, event) => {
    const updatedSchedules = [...selectedPlan?.schedules];
    console.log('updatedSchedules', updatedSchedules)
    updatedSchedules[index][event.target.name] = event.target.value;
    setSelectedPlan({ ...selectedPlan, schedules: updatedSchedules });
  };

  const handleScheduleChangeForNew = (index, event) => {
    const updatedSchedules = [...newSchedules];
    updatedSchedules[index][event.target.name] = event.target.value;
    setNewSchedules(updatedSchedules);
};

const addScheduleForNew = () => {
  setNewSchedules([...newSchedules, { time: '', event: '', image: null, notes: '' }]);
};

const handleCreateNewPlanForNew = async (e) => {
  e.preventDefault();
  // 空白の時間があるスケジュールを除外
  const filteredSchedules = newSchedules.filter(schedule => schedule.time.trim() !== '');

  const updatedPlan = {
      ...newPlan,
      tour_detail_id,
      schedules: filteredSchedules,
  };

  try {
      const response = await axios.post(`${apiUrl}/api/admin/plans/create`, updatedPlan);
      setPlans(response.data.plans);
      setNewPlan({
          campaign: '',
          duration: '',
          transfer: false,
          japanese_guide: false,
          availability: '毎日',
          ad_price: '',
          ch_price: '',
          family_price: '',
          includes: [''],
      });
      setNewSchedules([{ time: '', event: '', image: null, notes: '' }]); // 初期スケジュールをリセット
      setShowCreateForm(false);
  } catch (error) {
      console.error('Error creating plan:', error);
  }
};

const handleCancelEditForNew = () => {
  setSelectedPlan(null);
  setShowCreateForm(false);
  setNewPlan({
      campaign: '',
      duration: '',
      transfer: false,
      japanese_guide: false,
      availability: '毎日',
      ad_price: '',
      ch_price: '',
      family_price: '',
      includes: [''],
  });
  setNewSchedules([{ time: '', event: '', image: null, notes: '' }]);
};


  const addSchedule = () => {
    setNewPlan({
      ...newPlan,
      schedules: [...newPlan.schedules, { time: '', event: '', image: null, notes: '' }],
    });
  };

  const addScheduleToEdit = () => {
    setSelectedPlan((prevPlan) => ({
        ...prevPlan,
        schedules: [...(prevPlan.schedules || []), { time: '', event: '', image: null, notes: '' }],
    }));
};

console.log('selectedPlan', selectedPlan)

  const deleteSchedule = (index) => {
    setSelectedPlan((prevPlan) => {
      const updatedSchedules = prevPlan.schedules.filter((_, i) => i !== index);
      console.log('updatedSchedules', updatedSchedules)

      return {
        ...prevPlan,
        schedules: updatedSchedules,
      };
    });
  };

  const updateSchedule = (index, field, value) => {
    const updatedSchedules = plans.schedules.map((schedule, i) =>
      i === index ? { ...schedule, [field]: value } : schedule
    );
    setPlans((prevPlan) => ({
      ...prevPlan,
      schedules: updatedSchedules,
    }));
  };

    if (loading) {
      return <p>Loading...</p>;
    }

    // if (!plans.length) {
    //     return <p>No plans available.</p>;
    // }
    const formatPrice = (price) => {
      return new Intl.NumberFormat().format(price);
  };

  const generateSchema = () => {
    const schema = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        "itemListElement": plans.map((plan, index) => ({
            "@type": "Product",
            "name": plan.campaign,
            "description": `Duration: ${plan.duration}`,
            "offers": {
                "@type": "Offer",
                "priceCurrency": "AUD",
                "price": plan.ad_price,
                "availability": "https://schema.org/InStock"
            },
            "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": 4.5,
                "reviewCount": 10
            }
        }))
    };
    return JSON.stringify(schema, null, 2);
};

    return (
<div className={s.root}>
      {/* <button onClick={() => navigate(-1)} className={s.backButton}>
        戻る
      </button> */}
    <button onClick={() => navigate("/")} className={s.backButton}>
        ホームに戻る
    </button>
    <h1>プランを編集</h1>
    {showCreateForm ? (
        <PlanCreateForm
            newPlan={newPlan}
            newSchedules={newSchedules}
            onChange={handleNewPlanChange}
            onSubmit={handleCreateNewPlanForNew}
            onAddInclude={handleAddInclude}
            onIncludeChange={handleIncludeChange}
            onRemoveInclude={handleRemoveInclude}
            onScheduleChange={handleScheduleChangeForNew}
            onAddSchedule={addScheduleForNew}
            onCancel={handleCancelEdit}
        />
    ) : selectedPlan ? (
        <PlanEditForm
            selectedPlan={selectedPlan}
            onChange={handleEditPlanChange}
            onSubmit={handleEditPlan}
            onCancel={handleCancelEdit}
            onAddInclude={handleEditAddInclude}
            onIncludeChange={handleEditIncludeChange}
            onRemoveInclude={handleEditRemoveInclude}
            onScheduleChange={handleScheduleChange}
            onAddSchedule={addScheduleToEdit}
            deleteSchedule={deleteSchedule}
        />
    ) : (
        <>
            <button onClick={handleShowCreateForm} className={s.addButton}>
                プランを追加
            </button>
            <table className={s.planTable}>
                <thead>
                    <tr>
                        <th>プラン名</th>
                        <th>所要時間</th>
                        <th>空港送迎</th>
                        <th>日本語ガイド</th>
                        <th>料金（大人）</th>
                        <th>料金（子供）</th>
                        <th>料金（家族）</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {plans.map((plan) => (
                        <tr key={plan.id}>
                            <td>{plan.campaign}</td>
                            <td>{plan.duration}</td>
                            <td>{plan.transfer ? '✔️' : '❌'}</td>
                            <td>{plan.japanese_guide ? '✔️' : '❌'}</td>
                            <td>${formatPrice(plan.ad_price)}</td>
                            <td>${formatPrice(plan.ch_price)}</td>
                            <td>${formatPrice(plan.family_price)}</td>
                            <td>
                                <button onClick={() => setSelectedPlan(plan)}>編集</button>
                                <button onClick={() => handleDeletePlan(plan.id)}>削除</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    )}
     <script type="application/ld+json">
            {generateSchema()}
          </script>
</div>

  );
};

export default Plans;
